export type GridFormingMatrixType = 1 | 2;

export const getGridFormingMatrixType = (matrixType?: string | null): GridFormingMatrixType => {
  return matrixType === "TYPE_1" ? 1 : 2;
};
